import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
} from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect } from 'react';
import { ApiAccount, ApiBeneficiary, ApiStandingOrderDestination } from '../../../openapi';
import { useTerminateStandingOrderDestinationMutation } from '../../../api/standing-orders';
import { StandingOrderDestinationListItem } from './StandingOrderDestinationListItem';

export function TerminateStandingOrderDestinationDialog({
  destination,
  accounts,
  beneficiaries,
  onClose,
}: {
  destination: ApiStandingOrderDestination | undefined;
  accounts: ApiAccount[];
  beneficiaries: ApiBeneficiary[];
  onClose: () => void;
}) {
  const { t } = useTranslation();

  const mutation = useTerminateStandingOrderDestinationMutation();

  const handleTerminate = useCallback(() => {
    if (!mutation.isPending && destination?.id) {
      mutation.mutate({
        orderId: destination.orderId,
        destinationId: destination.id,
      });
    }
  }, [mutation, destination]);

  useEffect(() => {
    if (mutation.isSuccess) {
      onClose();
    }
  }, [mutation.isSuccess, onClose]);

  return (
    <Dialog open={Boolean(destination)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('Order destination termination')}</DialogTitle>
      <DialogContent>
        <List>
          {destination ? (
            <StandingOrderDestinationListItem
              destination={destination}
              accounts={accounts}
              beneficiaries={beneficiaries}
            />
          ) : null}
        </List>
        <Typography variant="body1">
          {t(
            'Are you sure you want to terminate this order destination? This action cannot be undone.',
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button
          onClick={handleTerminate}
          loading={mutation.isPending}
          variant="contained"
          color="error"
        >
          {t('Terminate')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
